"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARED_DOCUMENT_READER_PATHS = void 0;
/**
 * The web path of each audience's Documents space — where the notification
 * e-mail's "Lire le document" button leads, and where the reader routes live.
 *
 * Doctors share `/documents` with the administration list: like `/contracts`,
 * the page shown depends on the capability (`can_view_documents` for staff,
 * `can_read_documents` for readers). Assistants keep their `/assistant/*`
 * section.
 */
exports.SHARED_DOCUMENT_READER_PATHS = {
    substitute_doctor: '/documents',
    attending_doctor: '/documents',
    medical_assistant: '/assistant/documents',
};
